export default function Hero() {
  return (
    <section className="relative h-[200px] w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Lush%20vibrant%20botanical%20garden%20landscape%20with%20morning%20golden%20sunlight%20filtering%20through%20green%20foliage%20and%20flowering%20plants%2C%20professional%20nursery%20greenhouse%20with%20rows%20of%20healthy%20potted%20plants%20and%20flowers%2C%20peaceful%20garden%20atmosphere%20with%20natural%20lighting%2C%20soft%20focus%20background%2C%20professional%20photography%20style%2C%20warm%20natural%20tones%2C%20high%20quality%20botanical%20garden%20scene&width=1920&height=1080&seq=hero-garden-bg&orientation=landscape"
          alt="Beautiful garden landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight">
          Careers
        </h1>
      </div>
    </section>
  );
}